export default __webpack_public_path__ + "static/media/linkedin.8e42cac9.svg";